// extracted by mini-css-extract-plugin
module.exports = {"special-offers-list":"SpecialOffersPage_special-offers-list__1myaU"};